import Link from 'next/link'
import SvgIcon from '@components/shared/svg-icons/SvgIcon'
import HeaderAccount from './HeaderAccount'
import HeaderChat from './HeaderChat'
import HeaderScroll from './HeaderScroll'
import { MenuProvider, MenuToggle } from './MenuControl'
import SiteMenu from './SiteMenu'
import { MAIN_CONTENT_ID } from './mainContent'

import {
    ADD_OFFER_PAGE,
    DAT_PAGE,
    FIRM_BASE_PAGE,
    NEWS_PAGE,
    USER_WATCHED,
} from '@constants/routes'

import styles from './SiteHeader.module.css'

const HOST = process.env.NEXT_PUBLIC_HOST

export { MAIN_CONTENT_ID }

// Pasek i menu serwisu renderowane na serwerze; stan sesji, czat i otwieranie menu to wyspy klienckie.
export default function SiteHeader ({ logoOnly }) {
    return (
        <header className={styles.header} id="main-navb">
            <MenuProvider>
                <a className={styles.skip} href={`#${MAIN_CONTENT_ID}`}>Przejdź do treści</a>
                <div className={styles.bar}>
                    <Link className={styles.logo} href={HOST} prefetch={false}>
                        <img
                            alt="Samochody.pl, strona główna"
                            height="40"
                            src={`${HOST}/logo/logo-white.svg`}
                            width="139"
                        />
                    </Link>

                    { !logoOnly && <>
                        <MenuToggle className={styles.menuToggleDesk}>
                            Kategorie
                            <SvgIcon name="down" size="sm" />
                        </MenuToggle>
                        <nav aria-label="Na skróty" className={styles.quick}>
                            <Link href={HOST + FIRM_BASE_PAGE} prefetch={false}>Baza firm</Link>
                            <Link href={HOST + DAT_PAGE} prefetch={false}>Dekoder VIN</Link>
                            <Link className={styles.wide} href={HOST + NEWS_PAGE} prefetch={false}>Blog</Link>
                        </nav>

                        <div className={styles.actions}>
                            <Link aria-label="Obserwowane" className={`${styles.iconBtn} ${styles.desk}`} href={HOST + USER_WATCHED} prefetch={false}>
                                <SvgIcon name="heart" />
                            </Link>
                            <HeaderChat />
                            <HeaderAccount />
                            <Link className={styles.add} href={HOST + ADD_OFFER_PAGE} prefetch={false}>
                                <SvgIcon name="plus" />
                                <span>Dodaj<span className={styles.addWord}> ogłoszenie</span></span>
                            </Link>
                            <MenuToggle className={`${styles.iconBtn} ${styles.mob}`} label="Menu">
                                <SvgIcon name="menu" />
                            </MenuToggle>
                        </div>
                    </> }
                </div>
                { !logoOnly && <SiteMenu /> }
            </MenuProvider>
            <HeaderScroll />
        </header>
    )
}
